var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "resetPasswordUserModal", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c(
          "div",
          { staticClass: "modal-content first-modal-content" },
          [
            _vm._m(0),
            _c("div", { staticClass: "modal-body desc-text" }, [
              _vm.showTab == 1
                ? _c("div", { staticClass: "modal-title" }, [
                    _c("div", { staticClass: "title-text" }, [
                      _vm._v(
                        "Do you want to reset your password for the user?"
                      ),
                    ]),
                    _vm.user
                      ? _c("div", { staticClass: "bold-text" }, [
                          _vm._v(_vm._s(_vm.user.email_id)),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.showTab == 2
                ? _c("div", { staticClass: "modal-title" }, [
                    _c("div", { staticClass: "title-text" }, [
                      _vm._v("New Password"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "bold-text" },
                      [
                        _vm._v(_vm._s(_vm.generatedPassword) + " "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generatedPassword,
                              expression: "generatedPassword",
                            },
                          ],
                          ref: "password",
                          attrs: { type: "hidden" },
                          domProps: { value: _vm.generatedPassword },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.generatedPassword = $event.target.value
                            },
                          },
                        }),
                        _c(
                          "base-tooltip",
                          { attrs: { content: "Copy to clipboard" } },
                          [
                            _c("i", {
                              directives: [
                                {
                                  name: "clipboard",
                                  rawName: "v-clipboard:copy",
                                  value: _vm.generatedPassword,
                                  expression: "generatedPassword",
                                  arg: "copy",
                                },
                              ],
                              staticClass: "fa fa-clone",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("p", { staticClass: "mr-tp-10" }, [
                      _vm._v(
                        "you can copy the password and share it to the user."
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _c(
              "div",
              { staticClass: "modal-footer deactiveModal-bgcolor" },
              [
                _vm.showTab == 1
                  ? [
                      _c(
                        "div",
                        { staticClass: "col-sm-6 col-xs-12 mr-tp-10" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-block emergo-white-button",
                              attrs: { href: "#ConfirmationModal" },
                              on: { click: _vm.resetPassword },
                            },
                            [_vm._v("Yes, Proceed")]
                          ),
                        ]
                      ),
                      _vm._m(1),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header deactiveModal-bgcolor" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#resetPasswordUserModal",
          },
        },
        [_vm._v("×")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-6 col-xs-12 mr-tp-10" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-block emergo-blue-button",
          attrs: {
            "data-toggle": "modal",
            "data-target": "#resetPasswordUserModal",
          },
        },
        [_vm._v("Cancel")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }